
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiParametriGlobaliDialog extends Serenity.EntityDialog<UtentiParametriGlobaliRow, any> {
        protected getFormKey() { return UtentiParametriGlobaliForm.formKey; }
        protected getIdProperty() { return UtentiParametriGlobaliRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiParametriGlobaliRow.localTextPrefix; }
        protected getNameProperty() { return UtentiParametriGlobaliRow.nameProperty; }
        protected getService() { return UtentiParametriGlobaliService.baseUrl; }
        protected getDeletePermission() { return UtentiParametriGlobaliRow.deletePermission; }
        protected getInsertPermission() { return UtentiParametriGlobaliRow.insertPermission; }
        protected getUpdatePermission() { return UtentiParametriGlobaliRow.updatePermission; }

        protected form = new UtentiParametriGlobaliForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //
            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            }

            return buttons;
        }
    }
}